module.exports = __webpack_public_path__ + "img/still (2).6d7656af.jpg";